<template>
    <div class="contenedor_infContables">
        <div class="col-md-12">
            <boton-atras :nombre_ruta="'Finanzas-publicas'"/>
        </div>
        <div class="container text-center mb-5">
          <h1 class="bold300 text-uppercase" style=" font-weight:500;">Informes Contables</h1>
        </div>
        <div class="row contenedor_selects">
            <div class="col-md-6 col-12" v-if="listOpcionesInfCont">
                <label class="labelTextarea">Seleccione la opción a consultar</label>
                <px-select idSelect="informe_contable" placeholder="Seleccione" :options="listOpcionesInfCont" @KuramaSelect="opcSeleccionada = $event" :values="opcSeleccionada.value"></px-select>
            </div>
            <div class="col-md-6 col-12" v-if="listadoAnios">
                <label class="labelTextarea">Seleccione el año a consultar</label>
                <px-select idSelect="anios_ic" placeholder="Seleccione" :options="listadoAnios" @KuramaSelect="anioSeleccionado = $event" :values="anioSeleccionado.value" :disable="disableSanios_ic"></px-select>
            </div>
        </div>
        <div v-if="dataPorAnio" class="col-md-12">
            <table-section :sections="dataPorAnio" :urlServe="urlServe"/>
        </div>
        <span v-html="fecha_actualizacion"></span>
    </div>
</template>
<script>
import mapFun from '@/common/map-fn-types.js';
import InformeFinanzasPub from "@/services/rendicionDeCuentas/informeFinanzaPub/informeFinanzaPub.js";
const _serviciosInformeFinanzasPub = new InformeFinanzasPub();
import selectEjercicio from "../../../components/selectEjercicio.vue";
import cardCollapseDocs from '../../../components/cardCollapseDocs.vue';
import botonAtras from '../../button-atras.vue';
import tableSection from '../../../components/table.vue';
import DateFormat from "@/mixins/dateFormatMixin.js";

export default {
    mixins: [DateFormat],
    components: { selectEjercicio, cardCollapseDocs, botonAtras, tableSection},
    created(){
        window.scrollTo(0, 0);
        this.getListOpcInfCont()
    },
    data(){
        return{
            listOpcionesInfCont: [],
            listadoAnios: [],
            opcSeleccionada: { id: 0, value: null, text: "" },
            anioSeleccionado: { id: 0, value: null, text: "" },

            dataPorEstado: [],
            dataPorAnio: [],
            disableSanios_ic: true,
            fecha_actualizacion:''
        }
    },
    methods:{
        async getListOpcInfCont() {
            try {
                const response = await _serviciosInformeFinanzasPub.getOpcionesInformesContables(mapFun.opcionesInforCont);
                let fecha_texto = response.data[0].fecha_actualizacion;
                this.fecha_actualizacion = this.DateFormatText(fecha_texto);
                this.listOpcionesInfCont = response.data[0].contenido;
                this.listOpcionesInfCont = this.listOpcionesInfCont.map(function (mapeoSelect) {
                    return {
                        id: mapeoSelect.id,
                        value: mapeoSelect.descripcion+"-"+mapeoSelect.id,
                        text: mapeoSelect.titulo,
                    };
                });
            } catch (error) {
                console.log('error', error.message);
            }
        },
        async getInformacionPorEstado() {
            try {
                let ruta = mapFun.contenidoOpcInfoCont;
                let ruta_completa = ruta+this.opcSeleccionada.value+".json"
                // console.log("RUTAAAAA", ruta_completa);
                const response = await _serviciosInformeFinanzasPub.getInfoPorEstado(ruta_completa);
                let data_reverse = response.data.reverse(); //para mostrar los años actuales primeros
                this.dataPorEstado = data_reverse;
            } catch (error) {
                console.log('error', error.message);
            }
        },
        getListadoAniosPorEstado(){
            try {
                this.listadoAnios = this.dataPorEstado.map(function (mapeoSelect) {
                return {
                    id: mapeoSelect.id,
                    value: mapeoSelect.anio,
                    text: mapeoSelect.titulo,
                };
                });
            } catch (error) {
                console.log("error", error.message);
            }
        },
        getInformacionPorAnio(){
            try {
                this.dataPorAnio = this.dataPorEstado.filter(item => item.anio === this.anioSeleccionado.value);
                if(this.dataPorAnio.length >0){
                    let fecha_texto = this.dataPorAnio[0].fecha_actualizacion; 
                    this.fecha_actualizacion = this.DateFormatText(fecha_texto);
                }
            } catch (error) {
                console.log("error", error.message);
            }
        }
    },
    watch:{
        opcSeleccionada() {
            this.getInformacionPorEstado();
            this.anioSeleccionado = { id: 0, value: null, text: "" }
            if(this.opcSeleccionada){
                this.disableSanios_ic = false;
            }
        },
        dataPorEstado(){
            if(this.dataPorEstado){
                this.getListadoAniosPorEstado();
            }
        },
        anioSeleccionado(){
            if(this.anioSeleccionado){
                this.getInformacionPorAnio();
            }
        }

    }
        
}
</script>
<style scoped>
.contenedor_infContables{margin-bottom: 5rem}
</style>